import { useContext, useState } from 'react';
import { useDeleteUser } from './useDeleteUser';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { useHistory, useParams } from 'react-router-dom';
import { UseMutateFunction, useQueryClient } from 'react-query';
import { UsersV2Api } from '../../../api-client';
import { getApiConfiguration } from '../../../common';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UseDeleteUserModalFacade = () => {
  isDeleteUserModalOpen: boolean;
  toggleUserModalOpen: () => void;
  deleteUser: UseMutateFunction<AxiosResponse<void>, ErrorResponse, string>;
  isDeleting: false | true;
};

export const useDeleteUserModalFacade: UseDeleteUserModalFacade = () => {
  const { id } = useParams<{ id: string }>();
  const usersApiV2 = new UsersV2Api(getApiConfiguration());
  const { showNotification } = useContext(NotificationsContext);
  const history = useHistory();
  const queryClient = useQueryClient();
  const [isDeleteUserModalOpen, setIsDeleteUserModalOpen] = useState(false);

  const { mutate: deleteUser, isLoading: isDeleting } = useDeleteUser(usersApiV2, {
    onSuccess: () => {
      showNotification('User is successfully deleted');
      queryClient.invalidateQueries([`user-${id}`]).then();
      history.push('/users');
    },
    onError: () => {
      showNotification('An error occurred while deleting the user. Please try again');
    },
  });

  const toggleUserModalOpen = () => {
    setIsDeleteUserModalOpen((p) => !p);
  };

  return {
    isDeleteUserModalOpen,
    toggleUserModalOpen,
    deleteUser,
    isDeleting,
  };
};
